import { useEffect, useRef } from "react";
import { AccordionProps } from "./AccordionButton";

export const AccordionPane = (props: AccordionProps): JSX.Element => {
  const { answerContent, setPaneHeight } = props;
  const paneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (paneRef.current && setPaneHeight) {
      setPaneHeight(paneRef.current.offsetHeight + 0);
    }
  }, []);

  // x={{
  //   listStyleType: "circle",
  //   mx: "10px",
  //   px: "15px",
  //   li: {
  //     my: "10px",
  //     color: "primary",
  //     p: {
  //       color: "secondary",
  //     },
  //     "&::marker": {
  //       fontSize: 2,
  //       position: "relative",
  //       top: "10px",
  //     },
  //   },
  // }}
  return (
    <div
      ref={paneRef}
      sx={{
        variant: "text.bodyNew",
        p: 4,
        td: {
          i: {
            color: "primary",
          },
        },
        th: {
          py: "10px",
          pr: "15px",
        },
        tbody: {
          textAlign: "center",
        },
        ul: {
          listStyleType: "circle",
          px: 4,
          py: "10px",
          width: "100%",
          li: {
            py: "2px",
            i: {
              "&::before": {
                pr: "5px",
                color: "primary",
              },
            },
            "&::marker": {
              fontSize: 2,
              color: "black",
              position: "relative",
              top: "10px",
            },
          },
        },
        a: {
          variant: "text.link",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: answerContent,
      }}
    ></div>
  );
};

export default AccordionPane;
